module.exports = __webpack_public_path__ + "images/green@2x.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/green@2x.png
// module id = 1458
// module chunks = 0